import { render, staticRenderFns } from "./SetorAtendimentoDataTable.vue?vue&type=template&id=4f69adca"
import script from "./SetorAtendimentoDataTable.vue?vue&type=script&lang=ts"
export * from "./SetorAtendimentoDataTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports